import { render, staticRenderFns } from "./QuestionBankManage.vue?vue&type=template&id=61c39090&"
import script from "./QuestionBankManage.vue?vue&type=script&lang=js&"
export * from "./QuestionBankManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports